import { request } from '@utils';

const getEmailTemplates = async ({ params, payload }) => {
  const body = {
    body: payload,
  };
  const results = await request.post(
    `/v1/email-templates/filter?${new URLSearchParams(params)}`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const addEmailTemplate = async (payload) => {
  const body = {
    body: payload,
  };
  const results = await request.post('/v1/email-templates', body);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getEmailTemplateById = async (emailTemplateId) => {
  const results = await request.get(`/v1/email-templates/${emailTemplateId}`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const updateEmailTemplate = async (emailTemplateId, payload) => {
  const body = {
    body: payload,
  };
  const results = await request.patch(
    `/v1/email-templates/${emailTemplateId}`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const postAttachmentsToEmailTemplate = async ({
  emailTemplateId,
  document,
  lang,
}) => {
  const fd = new FormData();
  fd.append('files', document);

  const payload = {
    body: fd,
    header: {
      Accept: '*/*',
    },
  };

  const results = await request.post(
    `/v1/email-templates/${emailTemplateId}/attachments/${lang}`,
    payload
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const deleteAttachmentsFromEmailTemplate = async ({
  emailTemplateId,
  attachmentId,
  lang,
}) => {
  const results = await request.remove(
    `/v1/email-templates/${emailTemplateId}/attachments/${lang}/${attachmentId}`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const getEmailTemplatesEnums = async () => {
  const results = await request.get(`/v1/email-templates/enums`);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

export {
  getEmailTemplates,
  addEmailTemplate,
  getEmailTemplateById,
  updateEmailTemplate,
  postAttachmentsToEmailTemplate,
  deleteAttachmentsFromEmailTemplate,
  getEmailTemplatesEnums,
};
